import React, { useState, useEffect } from "react";
import PageSerch from "../SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import Gridview from "./Gridview";
import Listview from "./Listview";
import { oneKlicks } from "../../../SDK/oneclick";
import Paginationnew from "../../../Uitiles/Paginationnew";

const ArticalesList = () => {
  const [view, setView] = useState('list');
  const [liveArticles, setLiveArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleView = (selectedView) => setView(selectedView);

  useEffect(() => {
    fetchLiveArticles();
  }, [currentPage]);

  const fetchLiveArticles = async () => {
    try {
      const tableSchema = "articles";
      const tableName = "articles";
      const conditions = { status: "published" };
      const orderBy = "RAND()";
      const search = {};
      const pagination = { page: currentPage, limit: 20 };
      const margedata = [
        {
          target_table: "users",
          target_column: "id",
          target_value: "doctor_id",
          target_label: "doctors"
        },
        {
          target_table: "users",
          target_column: "id",
          target_value: "hospital_id",
          target_label: "hospitals"
        },
        {
          target_table: "specialities",
          target_column: "id",
          target_value: "categories",
          target_label: "specialities"
        }
      ];

      const response = await oneKlicks.read(
        tableSchema,
        tableName,
        conditions,
        orderBy,
        search,
        pagination,
        margedata
      );

      setLiveArticles(response.data);
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error("Error fetching articles:", error);
      setLiveArticles([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => setCurrentPage(page);

  if (loading) {
    return <div className="text-center p-4">Loading articles...</div>;
  }

  return (
    <>
      <div>
        <PageSerch />
        <DynamicBreadcrumbs />

        <main id="dc-main" className="dc-main dc-haslayout">
          <div className="container">
            <div className="dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
              <div className="main-page-wrapper">
                {/* View Toggle Buttons */}
                <div className="dc-description d-flex align-items-center mb-3" style={{ flexDirection: 'row-reverse' }}>
                  <div className="mr-3">
                    <button
                      className={`btn btn-light mr-2${view === 'list' ? ' active' : ''}`}
                      title="List View"
                      onClick={() => handleView('list')}
                    >
                      <i className="ti-view-list"></i>
                    </button>
                    <button
                      className={`btn btn-light${view === 'grid' ? ' active' : ''}`}
                      title="Grid View"
                      onClick={() => handleView('grid')}
                    >
                      <i className="ti-layout-grid2"></i>
                    </button>
                  </div>
                </div>

                <div className="dc-description">
                  <div className="elementor elementor-1003">
                    <section className="elementor-section elementor-top-section elementor-element elementor-element-cc501db elementor-section-full_width elementor-section-height-default elementor-section-height-default" style={{ padding: '0px' }}>
                      <div className="elementor-container elementor-column-gap-no">
                        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-984c6d3">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-224680e elementor-widget elementor-widget-dc_element_news_articles">
                              <div className="elementor-widget-container">
                                <div className={`dc-articlesholder ${view === 'list' ? 'd-flex' : ''}`}>
                                  {/* Articles List */}
                                  <div className={`row dc-articlesrow ${view === 'list' ? ' flex-column col-12 col-sm-12 col-md-9 col-xl-9' : ''}`}>
                                    {liveArticles.map((article, idx) => (
                                      view === 'grid'
                                        ? <Gridview article={article} key={idx} />
                                        : <Listview article={article} key={idx} />
                                    ))}
                                  </div>

                                  {/* Sidebar for List View */}
                                  {view === 'list' && (
                                    <div className="col-12 col-md-3 col-lg-3 col-xl-3 order-last d-flex flex-column align-items-stretch" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                      <aside id="dc-sidebar" className="dc-sidebar dc-sidebar-grid float-left mt-md-0 mt-lg-0 mt-xl-0 wl-100" style={{ height: "100%" }}>
                                        {/* Online Query Widget */}
                                        <div id="doctreat_query_online-3" className="dc-widget dc-sidebarquery dc-widget dc-onlineoptions widget_categories mb-4" style={{ width: "100%" }}>
                                          <figure className="dc-onlinuserimg d-flex justify-content-center align-items-center" style={{ margin: "0 auto" }}>
                                            <img src={require('../../../assets/images/onlinecn.jpg')} alt="Query online" style={{ height: "auto", display: "block", margin: "0 auto" }} />
                                            <figcaption style={{ position: "absolute", top: 10, right: 10 }}>
                                              <span>Live</span>
                                            </figcaption>
                                          </figure>
                                          <div className="dc-onlineoption-content text-center">
                                            <div className="dc-title">
                                              <h3>
                                                <span>Stop Waiting In Queue</span>
                                                Ask Query Online
                                              </h3>
                                            </div>
                                            <div className="dc-btnarea">
                                              <a href="#" className="dc-btn dc-btnactive" style={{ width: "100%" }}>
                                                Book Audio / Video Call
                                              </a>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Mobile App Widget */}
                                        <div id="doctreat_apps-5" className="dc-widget dc-sidebarapps dc-widget dc-mobileappoptions widget_categories mb-4" style={{ width: "100%" }}>
                                          <figure className="dc-appimgs d-flex justify-content-center align-items-center" style={{ margin: "0 auto" }}>
                                            <img src={require('../../../assets/images/sidebar02.jpg')} alt="App downloads" style={{ height: "auto", display: "block", margin: "0 auto" }} />
                                          </figure>
                                          <div className="dc-mobileapp-content text-center">
                                            <div className="dc-title">
                                              <h3>
                                                <span>Care On The GO</span>
                                                Get Mobile App
                                              </h3>
                                            </div>
                                            <div className="dc-description">
                                              <p>A dipisicing sed dotem eiusmou tempor incididunt ut labore</p>
                                            </div>
                                            <div className="dc-appemail-form d-flex justify-content-center align-items-center" style={{ gap: "8px" }}>
                                              <input type="email" name="app_email" className="form-control" placeholder="Email ID" required style={{ maxWidth: "180px" }} />
                                              <button type="submit" className="dc-get-app">
                                                <i className="fa fa-paper-plane"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Advertisement Widget */}
                                        <div id="doctreat_adds-5" className="dc-widget dc-sidebaradds dc-searchresultad widget_categories" style={{ width: "100%", textAlign: "center" }}>
                                          <img src={require('../../../assets/images/img-02.jpg')} alt="" style={{ height: "auto", display: "block", margin: "0 auto" }} />
                                        </div>
                                      </aside>
                                    </div>
                                  )}
                                </div>

                                {/* Pagination  currentPage, totalPages, handlePageChange*/}
                                <Paginationnew
                                  currentPage={currentPage}
                                  totalPages={totalPages}
                                  handlePageChange={handlePagination}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

      </div>

    </>
  );
};

export default ArticalesList;
